import axios from '@services/api/axios';

const api = {
  getBirthDays: () => axios.get('/birthday'),
};

export default api;
